import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IStaffSearch, IStaffDetail, IStaffFields } from "./staffType"

class StaffService {
    async page(searchVo: IStaffSearch) {
        const apiUrl = "/vrm-sa/staff/findPage";
        return await httpRequest.post<IPage<IStaffDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/staff/findById/${id}`;
        return await httpRequest.get<IStaffDetail>(apiUrl);
    }

    async insert(insertVo: IStaffFields) {
        const apiUrl = "/vrm-sa/staff/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IStaffFields) {
        const apiUrl = "/vrm-sa/staff/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async change(params:IStaffFields){
        const apiUrl = "/vrm-sa/staff/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
}

export const staffService = new StaffService();